<div class="data-table-scroll">
  <table class="data-table" [attr.aria-label]="ariaLabel()">
    <ng-content />
  </table>
</div>
